export enum FileType {
    pdf = "pdf",
    txt = "txt",
    csv = "csv",
    doc = "doc",
    docx = "docx",
    xls = "xls",
    xlsx = "xlsx",
    ppt = "ppt",
    pptx = "pptx",
    mp3 = "mp3",
    mp4 = "mp4",
    m4a = "m4a"
}
